
























































helpers = require('../../helpers.coffee')

view_model = {
  props: ['contact']

  data: ->
    task: new Task
    due_on_date: new Date()
    due_on_time: null
    past_dates:
      to: moment().subtract(1, 'day').toDate()

    confirming_destroy_reactivation: false
    recipient: null
    new_stage: { value: { stage_eq: 'smart_lead' }, text: 'Smart Lead'}

  methods:
    setDueOn: ->
      parts = @due_on_time.split(':')
      @task.due_on = moment(@due_on_date).hours(parts[0]).minutes(parts[1])

    scheduleReactivation: ->
      @task.referenceable_id = @recipient.id
      @task.referenceable_type = 'FlowRecipient'
      @task.metadata = { schedule_set_contact_stage: @new_stage.stage_eq }

      @tasks_resources.save @scheduleReactivationSuccess,
                            @unknownError,
                            @task

    scheduleReactivationSuccess: (data) ->
      @emitRefreshContactEvent()
      alertify.success 'Agendamento realizado com sucesso!'
      jQuery('#recipient-schedule-reactivation').modal('hide')
      IntercomCtrl.trackEvent('Reagendamento de contato no fluxo')

    toggleConfirmDestroyScheduledReactivation: ->
      @confirming_destroy_reactivation = !@confirming_destroy_reactivation

    destroyScheduledReactivation: ->
      @tasks_resources.destroy @destroyScheduledReactivationSuccess,
                               @unknownError,
                               @task

    destroyScheduledReactivationSuccess: ->
      @confirming_destroy_reactivation = false
      @emitRefreshContactEvent()
      alertify.success 'Agendamento cancelado com sucesso!'
      jQuery('#recipient-schedule-reactivation').modal('hide')

    emitRefreshContactEvent: ->
      EventsBus.$emit 'Contact::Refresh', id: @contact.id

    setStage: (data) ->
      @new_stage = data

  computed:
    due_on_text: ->
      return 'Selecione data e hora' unless @task.due_on
      "#{@task.formattedDueOn()} (#{@task.due_on.fromNow()})"

    save_task_text: ->
      return 'Atualizar' if @task.isPersisted()
      'Agendar'

    title_text: ->
      return 'Editar Reativação' if @task.isPersisted()
      'Agendar Reativação'

    valid_due_on: ->
      @task && @task.validDueOn() && @task.due_on && !@overdue

    overdue: ->
      return false if !@due_on_date || !@due_on_time
      parts = @due_on_time.split(':')
      task_due_on_date_time = moment(@due_on_date).hours(parts[0]).minutes(parts[1])
      return true if task_due_on_date_time.isBefore(moment())
      false

    next_valid_stages: ->
      [
        { value: { stage_eq: 'smart_lead' }, text: 'Smart Lead' }
        { value: { stage_eq: 'prospect' }, text: 'Prospect' }
        { value: { stage_eq: 'lead' }, text: 'Lead' }
        { value: { stage_eq: 'mql' }, text: 'MQL' }
        { value: { stage_eq: 'sql' }, text: 'SQL' }
        { value: { stage_eq: 'opportunity' }, text: 'Oportunidade' }
        { value: { stage_eq: 'client' }, text: 'Cliente' }
      ]

  watch:
    due_on_date: ->
      @setDueOn()

    due_on_time: ->
      @setDueOn()

    contact: ->
      return unless @contact
      @recipient = @contact.recipient

      if @recipient.reactivate_automatic_task.constructor == Task
        @task = @recipient.reactivate_automatic_task
      else
        @task = new Task type: 'AutomaticTask', service: 'AutomaticTasksServices::ReactivateRecipient'

      due_on = @task.due_on.clone()
      @due_on_date = due_on.toDate()
      @due_on_time = due_on.format 'HH:mm'
      contact = @contact
      previous_stage = @next_valid_stages.find (stage) -> stage.value.stage_eq == contact.previous_stage
      @new_stage = { stage_eq: previous_stage.value.stage_eq }

  created: ->
    @tasks_resources = new TasksResource
}

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/automatic_tasks/reactivate_recipient_modal.vue